import { ReactComponent as LogOutIcon } from "kustom-front/src/icons/log-out.svg";
import map from "lodash/map";
import React, { FunctionComponent } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Upsell, UpsellIdentifiers } from "@Types/upsells";
import { getFormattedTotalPrice, getTotalPrice, isSelected } from "@Utils/upsells";
import "./style.scss";
import UpsellItemMobile from "./UpsellItemMobile";

interface Props {
  hideUpsells: () => void;
  onSelectUpsell: (selectedUpsells: UpsellIdentifiers) => void;
  onSubmit: () => void;
  onSubmitWithoutUpsell: () => void;
  onUnselectUpsell: (selectedUpsells: UpsellIdentifiers) => void;
  selectedUpsellsTags: UpsellIdentifiers[];
  upsells: Upsell[];
}

const UpsellsMobile: FunctionComponent<Props> = ({
  hideUpsells,
  onSelectUpsell,
  onSubmit,
  onSubmitWithoutUpsell,
  onUnselectUpsell,
  selectedUpsellsTags,
  upsells,
}) => {
  const intl = useIntl();

  return (
    <div className="UpsellsMobile">
      <div className="UpsellsMobile-navigation">
        <div
          onClick={() => hideUpsells()}
          className="UpsellsMobile-navigation-label UpsellsMobile-navigation-label-back"
        >
          <LogOutIcon />
          <span>
            <FormattedMessage id={"cheerz_UpsellsModal_back"} />
          </span>
        </div>
        <div className="UpsellsMobile-navigation-title">
          <FormattedMessage id={"cheerz_UpsellsMobile_options"} />
          {getTotalPrice(upsells, selectedUpsellsTags) > 0 &&
            ` (+${getFormattedTotalPrice(upsells, selectedUpsellsTags, intl)})`}
        </div>
        <div
          onClick={() => onSubmit()}
          className="UpsellsMobile-navigation-label UpsellsMobile-navigation-label-cart"
        >
          <FormattedMessage id={"cheerz_UpsellsMobile_cart"} />
        </div>
      </div>
      <div onClick={onSubmitWithoutUpsell} className="UpsellsMobile-link-without-upsell">
        <FormattedMessage id={"cheerz_UpsellsModal_button__without_upsell"} />
      </div>

      <div className="UpsellsMobile-options">
        {map(upsells, (upsell) => {
          return (
            <UpsellItemMobile
              key={`${upsell.tag}-${upsell.value}`}
              isSelected={isSelected(upsell.tag, upsell.value, selectedUpsellsTags)}
              onSelectChange={() =>
                isSelected(upsell.tag, upsell.value, selectedUpsellsTags)
                  ? onUnselectUpsell(upsell)
                  : onSelectUpsell(upsell)
              }
              upsell={{
                description: upsell.description,
                imageUrl: upsell.imageUrl,
                price: upsell.price,
                title: upsell.title,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default UpsellsMobile;
